var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInviteReward = function SvgInviteReward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#FFF3F4",
    rx: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#invite-reward_svg__a)",
    fillRule: "evenodd",
    d: "M7.573 10h14.124a2 2 0 0 0 3.465 0h3.268c.63 0 1.143.512 1.143 1.143v13.714c0 .631-.512 1.143-1.143 1.143h-3.268a2 2 0 0 0-3.465 0H7.573a1.143 1.143 0 0 1-1.143-1.143V11.143c0-.631.511-1.143 1.143-1.143",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB5B5",
    d: "m21.697 10 .217-.125-.073-.125h-.144zm3.465 0v-.25h-.144l-.072.125zm0 16-.216.125.072.125h.144zm-3.465 0v.25h.144l.073-.125zm0-16.25H7.573v.5h14.124zm1.733 1a1.75 1.75 0 0 1-1.516-.875l-.433.25a2.25 2.25 0 0 0 1.949 1.125zm1.516-.875a1.75 1.75 0 0 1-1.516.875v.5c.833 0 1.56-.453 1.948-1.125zm3.484-.125h-3.268v.5h3.268zm1.393 1.393c0-.77-.624-1.393-1.393-1.393v.5c.493 0 .893.4.893.893zm0 13.714V11.143h-.5v13.714zM28.43 26.25c.769 0 1.393-.624 1.393-1.393h-.5c0 .493-.4.893-.893.893zm-3.268 0h3.268v-.5h-3.268zm-1.732-1a1.75 1.75 0 0 1 1.516.875l.432-.25a2.25 2.25 0 0 0-1.948-1.125zm-1.516.875a1.75 1.75 0 0 1 1.516-.875v-.5c-.833 0-1.56.453-1.95 1.125zm-14.341.125h14.124v-.5H7.573zM6.18 24.857c0 .77.623 1.393 1.393 1.393v-.5a.893.893 0 0 1-.893-.893zm0-13.714v13.714h.5V11.143zM7.573 9.75c-.77 0-1.393.624-1.393 1.393h.5c0-.493.4-.893.893-.893z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFDDC7",
    strokeDasharray: "1 2",
    strokeLinecap: "round",
    d: "M23.573 15v6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE1CC",
    d: "m11.939 21.99 4.298-8.51h1.254l-4.298 8.51zm.381-4.768q-.425 0-.796-.207a1.66 1.66 0 0 1-.589-.579 1.6 1.6 0 0 1-.207-.807v-.545q0-.317.12-.611.12-.295.349-.502.512-.48 1.124-.48.436 0 .807.218.37.207.578.578.218.37.218.797v.545a1.6 1.6 0 0 1-.458 1.124q-.491.47-1.146.469m0-2.662q-.218 0-.37.153a.5.5 0 0 0-.153.37v.546q0 .207.153.371a.53.53 0 0 0 .37.153q.263 0 .371-.142a.53.53 0 0 0 .175-.382v-.545a.49.49 0 0 0-.164-.371.52.52 0 0 0-.382-.153m4.8 7.44q-.676 0-1.134-.47a1.605 1.605 0 0 1-.458-1.124v-.533q0-.437.207-.797.219-.37.578-.589.372-.218.808-.218.632 0 1.134.47.218.228.338.523.13.294.131.61v.535q0 .306-.13.611-.12.295-.339.513-.469.47-1.134.469m0-2.662a.52.52 0 0 0-.381.164.5.5 0 0 0-.153.37v.535q0 .219.164.382a.48.48 0 0 0 .37.142.48.48 0 0 0 .371-.142.52.52 0 0 0 .164-.382v-.534a.52.52 0 0 0-.164-.382.46.46 0 0 0-.37-.153"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "invite-reward_svg__a",
    x1: 6.43,
    x2: 29.573,
    y1: 18,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF475D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0F23"
  })))));
};
export default SvgInviteReward;